export default "__VITE_ASSET__C58fJpCl__"